import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import Row from "components/Containers/Row";
import { colors, fontSize } from "style";
import Icon, { ICON_SIZE } from "components/Icon";
import { Spinner, TextLoader } from "components/Loader";

/**
 * MessageWithIcon
 *
 * @param {String}  messageId
 * @param {Object}  messageValues
 * @param {String}  iconType
 * @param {String}  iconSize
 * @param {Boolean} loading
 */
const MessageWithIcon = ({ messageId, iconType, messageValues, loading, iconSize = ICON_SIZE.small, ...props }) => (
  <Message gap="0.5rem">
    {loading ? (
      <Spinner size="1.5rem" />
    ) : (
      <IconContainer iconSize={iconSize} {...props}>
        <Icon type={iconType} size={iconSize} color="inherit" />
      </IconContainer>
    )}
    <span style={loading ? { width: "15rem" } : {}}>
      {loading ? <TextLoader /> : <FormattedMessage id={messageId} values={messageValues} />}
    </span>
  </Message>
);

const Message = styled(Row)`
  color: ${colors.purpleRainDark2};
  font-size: ${fontSize.xsmall};
`;

const IconContainer = styled.div`
  width: calc(${({ iconSize }) => iconSize} + 0.3rem);
  height: calc(${({ iconSize }) => iconSize} + 0.3rem);
  flex-shrink: 0;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ isSuccess, isError }) =>
    isSuccess ? colors.lightGreen : isError ? colors.lightRed : colors.lightYellow};
  color: ${({ isSuccess, isError }) => (isSuccess ? colors.green : isError ? colors.red : colors.darkYellow)};
`;

MessageWithIcon.propTypes = {
  messageId: PropTypes.string.isRequired,
  messageValues: PropTypes.object,
  iconType: PropTypes.string.isRequired,
  iconSize: PropTypes.string,
  loading: PropTypes.bool,
};

export default MessageWithIcon;
